import { render, staticRenderFns } from "./AddEditProductModal.vue?vue&type=template&id=634f2442&scoped=true&"
import script from "./AddEditProductModal.vue?vue&type=script&lang=js&"
export * from "./AddEditProductModal.vue?vue&type=script&lang=js&"
import style0 from "./AddEditProductModal.vue?vue&type=style&index=0&id=634f2442&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "634f2442",
  null
  
)

export default component.exports